import { BaseContainerModel } from '../../base-container.model';
import { bl_aat_claim_ocr_item_hdr_RowClass } from '../../../dbschema';

export class ClaimOcrItemContainerModel extends BaseContainerModel {
  bl_aat_claim_ocr_item_hdr: bl_aat_claim_ocr_item_hdr_RowClass = new bl_aat_claim_ocr_item_hdr_RowClass();
}
